import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { initializeAuth, browserLocalPersistence, inMemoryPersistence, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { Capacitor } from '@capacitor/core';


export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with explicit persistence
export const auth = initializeAuth(app, {
  persistence: typeof window !== 'undefined' 
    ? browserLocalPersistence 
    : inMemoryPersistence
});

// Explicitly set persistence to ensure it's properly configured
if (typeof window !== 'undefined') {
  setPersistence(auth, browserLocalPersistence).catch((error) => {
    // Silently handle persistence errors
  });
}

// Auth state management is handled by AuthContext.js
// No need for additional listeners here

export const db = getFirestore(app);
export const storage = getStorage(app);

// Only initialize messaging for web platform
export const messaging = !Capacitor.isNativePlatform() ? getMessaging(app) : null;

// Initialize Analytics (only for web platform)
export const analytics = !Capacitor.isNativePlatform() ? getAnalytics(app) : null;

// Initialize Performance (only for web platform)
export const performance = !Capacitor.isNativePlatform() ? getPerformance(app) : null;